export default "__VITE_ASSET__BO5l1S3o__"